import React from "react";
import Typography, { type TypographyVariant, } from "./Typography";

interface DialogContentTextProps extends Omit<React.HTMLAttributes<HTMLParagraphElement>, "color"> {
  component?: React.ElementType;
  variant?: TypographyVariant;
  children?: React.ReactNode;
}

const DialogContentText = React.forwardRef<HTMLParagraphElement, DialogContentTextProps>((props, ref) => {
  const {
    className,
    component: Component = "p",
    variant = "body1",
    children,
    ...other
  } = props;

  // MUI v4: Typography body1, color textSecondary, mb 12px (default Typography paragraph).
  return (
    <Typography
      ref={ref as React.Ref<HTMLElement>}
      component={Component}
      variant={variant}
      color="textSecondary"
      className={className}
      paragraph
      {...other}
    >
      {children}
    </Typography>
  );
});

DialogContentText.displayName = "DialogContentText";

export default DialogContentText;
